import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarioSsoModel } from 'src/app/models/calendario-sso/CalendarioSsoModel';
import { IDetalleSeguimientoPasstModel, ISeguimientoPasstModel } from 'src/app/models/interfaces/passt/ISeguimientoPasstModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CalendarioSsoService } from 'src/app/services/calendario-sso/calendario-sso.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-passt-actividad-reprogramar-dialog',
  templateUrl: './passt-actividad-reprogramar-dialog.component.html',
  styleUrls: ['./passt-actividad-reprogramar-dialog.component.css']
})
export class PasstActividadReprogramarDialogComponent implements OnInit {
  meses: Mes[] = [
    {value: '1', viewValue: 'Enero'},
    {value: '2', viewValue: 'Febrero'},
    {value: '3', viewValue: 'Marzo'},
    {value: '4', viewValue: 'Abril'},
    {value: '5', viewValue: 'Mayo'},
    {value: '6', viewValue: 'Junio'},
    {value: '7', viewValue: 'Julio'},
    {value: '8', viewValue: 'Agosto'},
    {value: '9', viewValue: 'Setiembre'},
    {value: '10', viewValue: 'Octubre'},
    {value: '11', viewValue: 'Noviembre'},
    {value: '12', viewValue: 'Diciembre'},
  ];
  constructor(public dialogRef: MatDialogRef<PasstActividadReprogramarDialogComponent>,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private calendarioService: CalendarioSsoService,
    @Inject(MAT_DIALOG_DATA) public model: IDetalleSeguimientoPasstModel) { 
      this.meses = new Array<Mes>();
      this.calendarioService.getCurrent(1)
      .subscribe((data: CalendarioSsoModel) => {
        if(data.mes>0){
          if(!model.eneroProgramado && data.mes<2)
            this.meses.push({value: '1', viewValue: 'Enero'})
          if(!model.febreroProgramado && data.mes < 3)
            this.meses.push({value: '2', viewValue: 'Febrero'})
          if(!model.marzoProgramado && data.mes < 4)
            this.meses.push({value: '3', viewValue: 'Marzo'})
          if(!model.abrilProgramado && data.mes < 5)
            this.meses.push({value: '4', viewValue: 'Abril'})
          if(!model.mayoProgramado && data.mes < 6)
            this.meses.push({value: '5', viewValue: 'Mayo'})
          if(!model.junioProgramado && data.mes < 7)
            this.meses.push({value: '6', viewValue: 'Junio'})
          if(!model.julioProgramado	&& data.mes < 8)
            this.meses.push({value: '7', viewValue: 'Julio'})
          if(!model.agostoProgramado && data.mes < 9)
            this.meses.push({value: '8', viewValue: 'Agosto'})
          if(!model.setiembreProgramado && data.mes < 10)
            this.meses.push({value: '9', viewValue: 'Setiembre'})
          if(!model.octubreProgramado && data.mes < 11)
            this.meses.push({value: '10', viewValue: 'Octubre'})
          if(!model.noviembreProgramado && data.mes < 12)
            this.meses.push({value: '11', viewValue: 'Noviembre'})
          // if(!model.diciembreProgramado && data.mes < 12)
          //   this.meses.push({value: '12', viewValue: 'Diciembre'})
        }
        if(this.meses.length<=0){
          this.alertDialogService.open('No se identificaron meses disponibles para poder reprogramar la actividad.');
          this.dialogRef.close();
        }
      });
      
    }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  } 
  
  Save(): void{
    this.dialogRef.close(this.model);
  }

  esValido(): boolean{
    let valido:boolean=true;
    
    if(!this.model.mesReprogramado)
      valido=false;
    if(!this.model.comentarios)
      valido=false;

    return valido;
  }
}
interface Mes {
  value: string;
  viewValue: string;
}